export default __webpack_public_path__ + "static/stop2-784425e8b62530629a7a4d16e33a019e.png";